
var BasePricesDashboardConstants = {
    INIT: 'init',
    CHANGE_EVENT: 'changeEvent',
    GOTO_DATE: 'gotoDate',
  };
  export default BasePricesDashboardConstants